<template>
  <div class="[ mk-be-artistIndex ] row">
    <div
      class="px-0 col-12 d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-md-center align-items-start"
      style="margin-bottom: 14px">
      <h2 class="ml-0 mb-3 mb-md-0">Creators</h2>

      <div class="d-flex flex-column flex-md-row">
        <a @click="addNewItem" class="btn btn-success mb-3 mb-md-0 ml-md-3">
          New Creator
        </a>
      </div>
    </div>

    <div class="container-fluid mb-4 px-0">
      <div class="row mx-0">
        <div class="col-12 px-0">
          <div class="[ artist-card hf-base-card ]">
            <paginated-table :headers="headers" ref="paginationRef">
            </paginated-table>



            <v-dialog v-model="dialog" max-width="600px" scrollable overlay-opacity="0.8" overlay-color="#000">
              <v-card class="[ mk-edit-add-artist-modal hf-dialog ]">
                <v-card-title>
                  <div class="w-100 d-flex justify-content-between align-items-center">
                    <h2 class="mb-0">{{ artist.id ? "Edit" : "Add" }} Creator</h2>

                    <a @click="cancelDialog" class="btn btn-close-modal" text>
                      <i class="fas fa-times"></i>
                    </a>
                  </div>
                </v-card-title>

                <v-card-text class="py-0">
                  <v-container class="[ admin-input-wrap ]">

                    <v-row>
                      <v-col cols="12">
                        <div class="[ upload-file-wrap ] d-flex position-relative">

                          <!-- Edit image preview -->
                          <div v-if="artist.image_url">
                            <art-upload-image :previewUploaded="previewUploaded" inputType="edit" :imageUrl="artist.image_url" />

                            <art-upload-image :previewUploaded="!previewUploaded" inputType="edit" :imageUrl="previewImage" />
                          </div>

                          <!-- Add image preview -->
                          <div v-else>
                            <art-upload-image :previewUploaded="previewUploaded" inputType="add" :imageUrl="null" />

                            <art-upload-image :previewUploaded="!previewUploaded" inputType="add" :imageUrl="previewImage" />
                          </div>

                          <v-file-input
                            v-model="file"
                            @change="previewImageUpload"
                            :clearable=false
                            ref="fileupload"
                            prepend-icon=""
                            suffix="Jpeg, jpg, png files under 10mb"
                            dark
                          ></v-file-input>
                        </div>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <label>Name</label>
                        <v-text-field outlined v-model="artist.name" placeholder="" class="text-field"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <label>Email</label>
                        <v-text-field outlined v-model="artist.email" placeholder="" class="text-field"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <label>From (Place of Birth)</label>
                        <v-text-field outlined v-model="artist.from" placeholder="" class="text-field"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <label>Year Born</label>
                        <v-text-field outlined v-model="artist.born" placeholder="" class="text-field"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <label>Bio</label>
                        <div class="tiptap-wrap">
                          <tiptap-vuetify
                            v-model="artist.bio"
                            :extensions="extensions"
                            placeholder="Write something ..."
                          />
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <label>Creator Website</label>
                        <v-text-field outlined v-model="artist.website" placeholder="e.g. https://linktr.ee/" class="text-field">
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <label>Organisation</label>
                        <v-select outlined :items="organisations" item-value="id" item-text="name"
                          v-model="artist.organisation_id" append-icon="fal fa-chevron-down" placeholder="Select">
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <label>Secondary Button URL</label>
                        <v-text-field outlined v-model="artist.tipping_url" placeholder="https://" class="text-field">
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <label>Secondary Button Title</label>
                        <v-text-field outlined v-model="artist.tipping_text" placeholder="Support me here" class="text-field">
                        </v-text-field>
                      </v-col>
                    </v-row>

                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <div class="d-flex justify-content-between align-items-center">
                          <a @click="cancelDialog" class="btn btn-grey" text>
                            Cancel
                          </a>

                          <a @click="saveItem" color="primary" text class="btn btn-success">
                            Save
                          </a>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-actions>

              </v-card>
            </v-dialog>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Artist from "../../models/Artist";
import axios from "axios";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";

export default {
  components: { TiptapVuetify },

  props: {
    organisations: {
      type: Array,
    }
  },
  data() {
    return {
      headers: [
        { text: "Name", value: "artistnameview" },
        { text: "Bio", value: "bio_no_tags" },
        {
          text: "Created At",
          value: "created_at",
          formatter: "date",
          format: "DD/MM/YYYY",
        },
        {
          text: "Updated At",
          value: "updated_at",
          formatter: "date",
          format: "DD/MM/YYYY",
        },
        {
          text: "Actions",
          value: "actions",
          download: true,
          sortable: false,
        },
      ],
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      dialog: false,
      artist: new Artist({}),
      file: null,
      previewImage: null,
      previewUploaded: false,
      previewFile: null,
      imageUrl: null,
    };
  },

  computed: {
    postUrl: function () {
      if (this.artist.id) {
        return `/api/v1/admin/artists/${this.artist.id}`;
      }
      return `/api/v1/admin/artists`;
    },
  },

  methods: {
    async getModelDetails() {
      return Artist.include("organisation").orderBy('name');
    },

    addNewItem() {
      this.artist = new Artist({});
      this.dialog = true;
      this.file = null;
    },

    async saveItem() {
      var formData = new FormData();
      Object.entries(this.artist).forEach(([key, value]) => {
        if (key != "file") {
            if(value == null) {
                value = '';
            }

            formData.append(key, value);
        }
      });

      var method = this.artist.id ? 'put' : 'post';
      formData.append("_method", method);

      if (this.file) {
        formData.append("file", this.file, this.file.name);
      }

      await axios
        .post(this.postUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          Vue.swal({
            title: ' ',
            text: 'Saved',
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 2000,
            showConfirmButton: false,
          });

          this.dialog = false;
          this.$refs.paginationRef.readDataFromAPI();
        })
        .catch(function (e) {
          console.log(e);
          if (e.response.status == 422) {
            var errorText = "";
            if (e.response.data.errors) {
              Object.entries(e.response.data.errors).forEach(([key, value]) => {
                value.forEach(errorMessage => {
                  errorText += "" + errorMessage + " <br>";
                });
              });
            } else {
              errorText += e.response.data.message;
            }
            Vue.swal('', errorText, 'error');
            return e.response;
          } else if(e.response.status == 413) {
            Vue.swal("", "Server Error Request Entity Too Large", "error");
          } else {
            Vue.swal('', 'Server error', 'error');
          }
        });
    },

    editItem(data) {
      this.dialog = true;
      this.artist = data;
    },

    deleteItem(data) {
      this.artist = data;
      this.$swal({
        title: "Are you sure you want to delete this?",
        customClass: {
          confirmButton: "order-2 btn btn-primary ml-1",
          cancelButton: "order-1 btn btn-grey mr-1",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Confirm",
        iconHtml: "",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let artist = new Artist(this.artist);
          artist.delete().then((response) => {
            this.$refs.paginationRef.readDataFromAPI();

            Vue.swal({
              title: ' ',
              text: 'Deleted',
              icon: 'success',
              toast: true,
              position: 'top-end',
              timer: 2000,
              showConfirmButton: false,
            });

          });
        }
      });
    },
    previewImageUpload() {
      this.previewImage = URL.createObjectURL(this.file);
      this.previewUploaded = true;
    },
    cancelDialog() {
      this.previewUploaded = false;
      this.$refs.fileupload.reset();
      this.dialog = false;
    },
    async download(data) {
      window.location.href = "/admin/download-email/"+data.id;
    },
  },
};
</script>
